import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-center text-xl mb-2"
};
import FormGroup from "@/modules/vue/components/FormGroup.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CareerStats',
  props: {
    stats: null
  },
  setup(__props) {
    const props = __props;
    const cStats = computed(() => {
      const c = collect(props.stats);
      return {
        seasons: c.sum('seasons'),
        matches: c.sum('matches'),
        goals: c.sum('goals'),
        yellow: c.sum('yellow'),
        yellowRed: c.sum('yellowRed'),
        red: c.sum('red')
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "title")]), _createVNode(FormGroup, {
        label: _ctx.$t('seasons'),
        narrow: "",
        "value-width-ratio": .5
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.stats.length), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        label: _ctx.$t('matches'),
        narrow: "",
        "value-width-ratio": .5
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(cStats).matches), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        label: _ctx.$t('goals'),
        narrow: "",
        "value-width-ratio": .5
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(cStats).goals), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        label: _ctx.$t('yellow'),
        narrow: "",
        "value-width-ratio": .5
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(cStats).yellow), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        label: _ctx.$t('yellow_red'),
        narrow: "",
        "value-width-ratio": .5
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(cStats).yellowRed), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        label: _ctx.$t('red'),
        narrow: "",
        "value-width-ratio": .5
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(cStats).red), 1)]),
        _: 1
      }, 8, ["label"])]);
    };
  }
});